<template>
  <TWModal
    :title="$t('functional.areYouSure')"
    :loading="loading"
    :show="show"
    @close="$emit('close')"
    :allow-outside-click-to-close="false"
  >
    <template v-slot:content>
      <p>{{ text }}</p>
    </template>
    <template v-slot:controls>
      <BaseButton
        @click.native="$emit('close')"
        variant="invisible"
        size="small"
        :ec="`${integration}_disconnect_modal`"
        et="cancel_button"
      >
        {{ $t('functional.cancel') }}
      </BaseButton>
      <BaseButton
        @click.native="disconnect"
        variant="danger"
        size="small"
        :ec="`${integration}_disconnect_modal`"
        et="disconnect_button"
      >
        {{ $t('companySettings.integrations.disconnect.affirmDisconnect') }}
      </BaseButton>
    </template>
  </TWModal>
</template>

<script>
import TWModal from '@/components/tailwind/Modal.vue';
import BaseButton from '@/components/library/buttons/BaseButton.vue';

export default {
  name: 'ConfirmIntegrationDisconnectModal',
  components: {
    TWModal,
    BaseButton,
  },
  data() {
    return {
      loading: false,
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
    },
    integration: {
      type: String,
    },
  },
  methods: {
    async disconnect() {
      this.loading = true;
      this.$emit('loadingStateChanged', true);

      await this.$store.dispatch('integrations/DISCONNECT_INTEGRATION_INSTANCE', { slug: this.integration });
      this.$emit('loadingStateChanged', false);
      this.loading = false;
      this.$emit('close');
    },
  },
};
</script>
